export default __webpack_public_path__ + "static/media/small.889f2852.jpg";